import { Modal, Box, Button, Alert, TextField } from "@mui/material";
import React, { useState } from "react";

import { modalStyle } from "../constants";
import { sendPostRequest, formatPhoneNumber } from "../../utils";

const initialState = {
  name: "",
  phone_number: "",
  email: "",
  city: "",
  address: "",
  apartment: "",
  postal_code: "",
};

const AddSubscriberModal = ({ open, handleClose, doFetchCustomers }) => {
  const [inputs, setInputs] = useState(initialState);
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    if (name === "phone_number" && value && !/^[0-9]+$/.test(value)) return;

    setInputs((values) => ({ ...values, [name]: value }));
  };

  const doAddSubscriber = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    sendPostRequest("add-subscriber", {
      ...inputs,
      phone_number: formatPhoneNumber(inputs.phone_number),
    })
      .then((res) => res.json())
      .then((data) => {
        setIsSubmitting(false);
        if (data.errMessage) {
          setError(data.errMessage);
        }
        if (data.message) {
          doFetchCustomers();
          handleClose();
        }
      })
      .catch(() => {
        setIsSubmitting(false);
        setError("Failed to add member. Please try again.");
      });
  };

  const emailError =
    inputs.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputs.email)
      ? "Enter a valid email address."
      : "";
  const phoneError =
    inputs.phone_number && inputs.phone_number.length !== 10
      ? "Enter the 10-digit number."
      : "";
  const isDisabled =
    !inputs.name ||
    !inputs.phone_number ||
    Boolean(emailError) ||
    Boolean(phoneError) ||
    isSubmitting;

  return (
    <Modal open={open} onClose={handleClose} className="relative">
      <Box sx={modalStyle}>
        {error ? (
          <div className="my-4">
            <Alert severity="error">{error}</Alert>
          </div>
        ) : null}

        <form onSubmit={doAddSubscriber}>
          <h2 className="text-lg font-semibold">Add a member</h2>
          <p className="mb-3 text-sm text-gray-600">
            For someone who paid by cash or e-transfer. Fields marked * are
            required.
          </p>

          <p className="mt-3 mb-1 text-xs font-semibold uppercase tracking-wide text-gray-500">
            Contact
          </p>
          <div className="my-2">
            <TextField
              fullWidth
              size="small"
              label="Name *"
              name="name"
              autoFocus
              onChange={handleChange}
              value={inputs.name}
            />
          </div>
          <div className="my-2 flex items-start">
            <span className="mr-2 mt-2">
              {process.env.REACT_APP_DEFAULT_AREA_CODE}
            </span>
            <TextField
              fullWidth
              size="small"
              label="Phone # *"
              name="phone_number"
              inputProps={{ inputMode: "numeric", maxLength: 10 }}
              placeholder="5145550000"
              error={Boolean(phoneError)}
              helperText={phoneError || "Digits only, no spaces or dashes"}
              onChange={handleChange}
              value={inputs.phone_number}
            />
          </div>
          <div className="my-2">
            <TextField
              fullWidth
              size="small"
              label="E-mail"
              name="email"
              type="email"
              error={Boolean(emailError)}
              helperText={emailError}
              onChange={handleChange}
              value={inputs.email}
            />
          </div>

          <p className="mt-4 mb-1 text-xs font-semibold uppercase tracking-wide text-gray-500">
            Address
          </p>
          <div className="my-2">
            <TextField
              fullWidth
              size="small"
              label="Street"
              name="address"
              placeholder="123 Main Street"
              onChange={handleChange}
              value={inputs.address}
            />
          </div>
          <div className="my-2 grid grid-cols-2 gap-2">
            <TextField
              fullWidth
              size="small"
              label="Apartment"
              name="apartment"
              onChange={handleChange}
              value={inputs.apartment}
            />
            <TextField
              fullWidth
              size="small"
              label="City"
              name="city"
              onChange={handleChange}
              value={inputs.city}
            />
          </div>
          <div className="my-2">
            <TextField
              fullWidth
              size="small"
              label="Postal Code"
              name="postal_code"
              placeholder="J0E 2K0"
              onChange={handleChange}
              value={inputs.postal_code}
            />
          </div>
          <div className="flex justify-center mt-4">
            <Button
              type="submit"
              variant="contained"
              disabled={isDisabled}
              color="success"
            >
              {isSubmitting ? "Adding..." : "Add Member"}
            </Button>
            <span className="ml-2">
              <Button
                type="button"
                variant="outlined"
                onClick={handleClose}
                disabled={isSubmitting}
              >
                Cancel
              </Button>
            </span>
          </div>
        </form>
      </Box>
    </Modal>
  );
};

export default AddSubscriberModal;
